import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/5_cats-6/5_cats-6"
 * Contains 6 texture(s)
 */
export class CardsFront5Cats6Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/5_cats-6/5_cats-6';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '4-spades.png',
        '4-hearts.png',
        '4-diamonds.png',
        '4-clubs.png',
        '3-spades.png',
        '3-hearts.png'
    ] as const;
}
